import React from 'react';
import PropTypes from 'prop-types';
import { DISABLED_COUNT_TYPES } from '../types';
import { type LivefireCardType, livefireItemTypes } from '@/constants';

/**
 * CardCountDetails component
 */
export function CardCountDetails({ count, type }: { count: number; type: LivefireCardType }) {
  if (!count || DISABLED_COUNT_TYPES.includes(type)) {
    return null;
  }

  let label = 'open';
  if (type === 'click') {
    label = 'click';
  } else if (type === 'reaction_like') {
    label = 'like';
  } else if (type === 'play' || type === 'video_watched') {
    label = 'play';
  }

  if (count !== 1) {
    label = `${label}s`;
  }

  return (
    <div className="count-details">
      <strong className="count">{count}</strong>
      <span className="countLabel">{label}</span>
    </div>
  );
}

CardCountDetails.propTypes = {
  type: PropTypes.oneOf(livefireItemTypes.items).isRequired,
  count: PropTypes.number.isRequired,
};

export default CardCountDetails;
